import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('souvenir');

const GET_SOUVENIRS = define('GET_SOUVENIRS', true);
const GET_SOUVENIR = define('GET_SOUVENIR', true);
const CREATE_SOUVENIR = define('CREATE_SOUVENIR', true);
const UPDATE_SOUVENIR = define('UPDATE_SOUVENIR', true);
const DELETE_SOUVENIR = define('DELETE_SOUVENIR', true);

const initialState = {
  isLoading: true,
  souvenirs: [],
  souvenir: {},
  processing: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SOUVENIRS.PENDING:
    case GET_SOUVENIRS.REJECTED:
    case GET_SOUVENIR.PENDING:
    case GET_SOUVENIR.REJECTED:
      return {
        ...state,
        isLoading: true
      };
    case GET_SOUVENIRS.RESOLVED:
      return {
        ...state,
        isLoading: false,
        souvenirs: action.data
      };
    case GET_SOUVENIR.RESOLVED:
      return {
        ...state,
        isLoading: false,
        souvenir: action.data
      };
    case UPDATE_SOUVENIR.PENDING:
    case DELETE_SOUVENIR.PENDING:
      return {
        ...state,
        processing: true
      };
    case UPDATE_SOUVENIR.RESOLVED:
    case UPDATE_SOUVENIR.REJECTED:
    case DELETE_SOUVENIR.RESOLVED:
    case DELETE_SOUVENIR.REJECTED:
      return {
        ...state,
        processing: false
      };
    default: return state;
  }
};

export const actions = {
  getSouvenirs: () => ({
    type: GET_SOUVENIRS,
    promise: api.get('/souvenir'),
    error: 'Unable to get souvenirs'
  }),
  getSouvenir: (id) => ({
    type: GET_SOUVENIR,
    promise: api.get(`/souvenir/${id}`),
    error: 'Unable to get souvenir'
  }),
  createSouvenir: data => ({
    type: CREATE_SOUVENIR,
    promise: api.post('/souvenir', data),
    success: 'Souvenir has been created',
    error: 'Unable to create souvenir'
  }),
  updateSouvenir: (id, data) => ({
    type: UPDATE_SOUVENIR,
    promise: api.put(`/souvenir/${id}`, data),
    success: 'Souvenir has been updated',
    error: 'Unable to update souvenir'
  }),
  deleteSouvenir: id => ({
    type: DELETE_SOUVENIR,
    promise: api.delete(`/souvenir/${id}`),
    success: 'Souvenir has been deleted',
    error: 'Unable to delete souvenir'
  })
};



// WEBPACK FOOTER //
// ./src/ducks/souvenir.js